<template>
  <div class="row justify-content-md-center">
    <div class="col-12 col-md-6 col-xl-4 my-5">
        <h2 class="col-12 my-5"><strong style="color:#AF272F;">Rejoin Cherrytree</strong></h2>
            <form class="row mx-auto" v-on:submit.prevent="submitRequest">
                <label class="col-12 col-sm-5">
                    Name<sup>*</sup>
                </label>
                <input
                    v-model="name"
                    name="Name"
                    type="text"
                    class="col-12 col-sm-7 form-control"
                    v-validate="'required'"
                />

                <label class="col-12 col-sm-5">
                    Email<sup>*</sup>
                </label>
                <input 
                    v-model="email"
                    name="Email"
                    type="email"
                    class="col-12 col-sm-7 form-control"
                    v-validate="{rules: {required: phone? false: true}}"
                />

                <label class="col-12 col-sm-5">
                    Contact Number<sup>*</sup>
                </label>
                <input
                    v-model="phone"
                    name="Contact Number"
                    type="text"
                    class="col-12 col-sm-7 form-control"
                    v-validate="{rules: {required: email? false: true}}"

                />

                <label class="col-12 col-sm-5">
                    Membership Number<br> (If you can remember)
                </label>
                <input
                    v-model="membershipNumber"
                    name="Membership Number"
                    type="text"
                    class="col-12 col-sm-7 form-control"
                />

                <label class="col-12 col-sm-5">
                    Membership Level<sup>*</sup>
                </label>
                <div
                    class="col-12 col-sm-7 align-self-end"
                >    
                    <input
                        v-model="membershipLevel"
                        type="radio"
                        value="Cherrytree Silver - Free as our entry level memebership (save up to 25% off RRP)"
                        name="Membership Level"
                        id="MembershipLevel"
                        v-validate="'required'"
                    >
                    <label for="MembershipLevel" class="radioLabel ml-1"><strong>Cherrytree Silver</strong> - Free as our entry level memebership (save up to 25% off RRP)</label>
                </div>
                <label class="col-12 col-sm-5">
                </label>
                <div
                    class="col-12 col-sm-7 align-self-end mt-sm-2"
                >    
                    <input
                        v-model="membershipLevel"
                        type="radio"
                        value="Cherrytree Gold - $250 to access wholesale+ pricing (save up to 60% off RRP)"
                        id="MembershipLevelGold"
                        name="Membership Level"
                    >
                    <label for="MembershipLevelGold" class="radioLabel ml-1"><strong>Cherrytree Gold</strong> - $250 to access wholesale+ pricing (save up to 60% off RRP)</label>
                </div>
                <div
                    class="col-12 align-content-center my-5"
                >
                    <ButtonWithLoading
                        class="mx-auto mt-2 d-block"
                        type="submit"
                        :state="submitState"
                        text="Send Request"
                        loadingText="Sending Request"
                        successText="Request Sent"
                        errorText="Error Sending Request"
                    ></ButtonWithLoading>
                
                </div>
                <p style="color:#AF272F;"><sup>*</sup> = Required</p>
            </form>
            <div v-if="errors.all().length > 0" class="alert alert-danger">
            <li v-for="(error, index) in errors.all()" :key="index">{{ error }}</li>
            </div>
            <div v-if="errorMessage" class="alert alert-danger">
            {{errorMessage}}
            </div>
        </div>
    </div>
</template>

<script>
import ButtonWithLoading from "@/components/buttonWithLoading";
import {postRejoinRequest} from "@/network/contactRequests";

export default {
  name: "RejoinRequest",
  components: {
    ButtonWithLoading
  },
  data(){
      return {
          name: "",
          email: "",
          phone: "",
          membershipNumber: "",
          membershipLevel: "",
          memberShipLevelOptions: [
            "Cherrytree Silver - Free as our entry level memebership (save up to 25% off RRP)",
            "Cherrytree Gold - $250 to access wholesale+ pricing (save up to 60% off RRP)"
          ],
          submitState:null,
          errorMessage:null
      }
  },
  computed: {

  },
  methods: {
      submitRequest(){
        this.$validator.validateAll().then(valid => {
            if (!valid) {
            return;

            }
            this.submitState = "loading";

            const { name, email, phone, membershipNumber, membershipLevel } = this;

            postRejoinRequest({ name, email, phone, membershipNumber, membershipLevel },
            () => { //success
                this.submitState = "success";

                    // delay redirect so user sees success
                    setTimeout(() => {
                    this.submitState = null;
                    this.errorMessage = "";
                }, 5000);
            },
            error =>{
                this.errorMessage = error.message || "Error with sending form";
                    this.submitState = "error";
                    setTimeout(() => {
                        this.submitState = null
                }, 3000);
            })
        });
    }
  }
}
</script>

<style lang="scss" scoped>
    .radioLabel {
        font-weight: normal;
        display: inline;
    }
</style>
